<template>
  <div class="my_container">
    <div class="my_breadcrumb_box">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ name: 'Union' }">联盟生态</el-breadcrumb-item>
        <el-breadcrumb-item>企业列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="contacts_list_box">
      <div class="glag_all margin_bottom_30">
        <div class="title_top_hr">
          <p>
            <span>我关注的企业</span>
          </p>
          <el-divider></el-divider>
        </div>
        <none-view v-if="myContacts.length === 0" :login="load.my.login" :loading="load.my.loading" :data="myContacts" :text="load.my.text"></none-view>
        <div v-if="myContacts.length > 0" class="contacts_list">
          <div class="contacts_list_item lf" v-for="(item, index) in myContacts" :key="item.id">
            <div class="contacts_list_item_top">
              <img :src="item.portrait" alt="头像" @click="userJump(item.user_id)">
              <dl class="contacts_info">
                <dt>
                  <a @click="userJump(item.user_id)">{{item.user_name}}</a>
                </dt>
                <dd>{{item.content}}</dd>
              </dl>
            </div>
            <div class="contacts_list_item_bottom">
               <p class="contacts_other lf">
                 <span>{{item.fans_count}}</span> 人关注
               </p>
               <p class="contacts_btn rt">
                 <button v-show="item.is_follow === 0"
                 class="greenglga_btn"
                 @click = "addFollow(item.user_id, index, 'my')"
                 >
                   <i class="add">+</i>
                   <span>关注</span>
                 </button>
                 <button v-show="item.is_follow === 1"
                 :class="myHoverIndex === index ? 'greenglga_btn greenglga_btn_cancle' : 'greenglga_btn greenglga_btn_confirm'"
                 @mouseenter="myHoverIndex = index"
                 @mouseleave="myHoverIndex = ''"
                 @click = "cancelFollow(item.user_id, index, 'my')">
                   <span v-show="myHoverIndex !== index">已关注</span>
                   <span v-show="myHoverIndex === index">取消关注</span>
                 </button>
               </p>
            </div>
          </div>
        </div>
        <page-view v-if="myContacts.length > 0" :list="myContacts" :limit="myContactsPage.limit" :type="load.my.type" @pageType='pageType'></page-view>
      </div>
      <div class="glag_all margin_bottom_30">
        <div class="title_top_hr">
          <p>
            <span>企业列表</span>
          </p>
          <el-divider></el-divider>
        </div>
        <none-view v-if="contactsList.length === 0" :login="load.list.login" :loading="load.list.loading" :data="contactsList" :text="load.list.text"></none-view>
        <div v-if="contactsList.length > 0" class="contacts_list">
          <div class="contacts_list_item lf" v-for="(item, index) in contactsList" :key="item.id">
            <div class="contacts_list_item_top">
              <img :src="item.portrait" alt="头像" @click="userJump(item.user_id)">
              <dl class="contacts_info">
                <dt>
                  <a @click="userJump(item.user_id)">{{item.user_name}}</a>
                </dt>
                <dd>{{item.content}}</dd>
              </dl>
            </div>
            <div class="contacts_list_item_bottom">
               <p class="contacts_other lf">
                 <span>{{item.fans_count}}</span> 人关注
               </p>
               <p class="contacts_btn rt">
                 <button v-show="item.is_follow === 0"
                 class="greenglga_btn"
                 @click = "addFollow(item.user_id, index, 'list')"
                 >
                   <i class="add">+</i>
                   <span>关注</span>
                 </button>
                 <button v-show="item.is_follow === 1"
                 :class="hoverIndex === index ? 'greenglga_btn greenglga_btn_cancle' : 'greenglga_btn greenglga_btn_confirm'"
                 @mouseenter="hoverIndex = index"
                 @mouseleave="hoverIndex = ''"
                 @click = "cancelFollow(item.user_id, index, 'list')">
                   <span v-show="hoverIndex !== index">已关注</span>
                   <span v-show="hoverIndex === index">取消关注</span>
                 </button>
               </p>
            </div>
          </div>
        </div>
        <page-view v-if="contactsList.length > 0" :list="contactsList" :limit="contactsListPage.limit" :type="load.list.type" @pageType='pageType'></page-view>
      </div>
    </div>
  </div>
</template>

<script>
import none from '../Public/none.vue'
import page from '../Public/page.vue'

export default {
  components: {
    noneView: none,
    pageView: page
  },
  data () {
    return {
      myHoverIndex: '', // 我关注的入驻企业鼠标移入记录下标
      hoverIndex: '', // 入驻企业鼠标移入记录下标
      load: { // 加载项的参数
        my: {
          login: true, // 是否需要验证登陆
          loading: true, // 加载动画开关
          txet: '您还未关注任何企业！', // 我的人脉列表为空时的提示信息
          type: 'my' // 分页的类型
        },
        list: {
          login: false, // 是否需要验证登陆
          loading: true, // 加载动画开关
          txet: '暂无任何用户', // 人脉列表为空时的提示信息
          type: 'list' // 分页的类型
        }
      },
      myContacts: [], // 我的人脉
      myContactsPage: {
        limit: 4,
        page: 1
      }, // 我的人脉分页
      contactsList: [], // 人脉列表
      contactsListPage: {
        limit: 20,
        page: 1
      } // 人脉列表分页
    }
  },
  created () {
    this.getMyContacts(this.myContactsPage)
    this.getContactsList(this.contactsListPage)
  },
  methods: {
    // 获取我的人脉列表
    getMyContacts (page) {
      const vueThat = this
      vueThat.myApi.getMyContacts(page).then((res) => {
        vueThat.load.my.loading = false
        if (res.data.code === 200) {
          vueThat.myContacts = [...vueThat.myContacts, ...res.data.data.follow_list]
        }
      })
    },
    // 获取人脉列表
    getContactsList (page) {
      const vueThat = this
      vueThat.myApi.contactsList(page).then((res) => {
        vueThat.load.list.loading = false
        if (res.data.code === 200) {
          vueThat.contactsList = [...vueThat.contactsList, ...res.data.data]
        }
      })
    },
    // 加载更多
    pageType (num, type) {
      let page = {}
      if (type === 'my') {
        page = this.myContactsPage
        page.page = num
        this.getMyContacts(this.myContactsPage)
      } else {
        page = this.contactsListPage
        page.page = num
        this.getContactsList(this.contactsListPage)
      }
    },
    // 个人中心页面跳转
    userJump (rid) {
      const routeData = this.$router.resolve({
        path: '/personalCenter/:id',
        query: { id: rid }
      })
      window.open(routeData.href, '_blank')
    },
    // 添加关注
    addFollow (id, index, type) {
      const vueThat = this
      vueThat.myApi.addFollow({ user_id: id }).then((res) => {
        if (res.data.code === 200) {
          vueThat.$alert('关注成功', '温馨提示', {
            type: 'success',
            iconClass: 'iconfont icon-icon_richeng_btn_pass',
            confirmButtonText: '确定',
            showClose: false,
            callback: action => {
              if (type === 'my') {
                vueThat.myContacts[index].is_follow = 1
                vueThat.myContacts[index].fans_count += 1
              } else {
                vueThat.contactsList[index].is_follow = 1
                vueThat.contactsList[index].fans_count += 1
              }
            }
          })
        }
      })
    },
    // 取消关注
    cancelFollow (id, index, type) {
      const vueThat = this
      vueThat.$confirm('确认取消关注？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        vueThat.myApi.cancelFollow({ user_id: id }).then((res) => {
          if (res.data.code === 200) {
            vueThat.$alert('取消关注成功', '温馨提示', {
              type: 'success',
              iconClass: 'iconfont icon-icon_richeng_btn_pass',
              confirmButtonText: '确定',
              showClose: false,
              callback: action => {
                if (type === 'my') {
                  vueThat.myContacts[index].is_follow = 0
                  vueThat.myContacts[index].fans_count -= 1
                } else {
                  vueThat.contactsList[index].is_follow = 0
                  vueThat.contactsList[index].fans_count -= 1
                }
              }
            })
          }
        })
      }).catch(() => {})
    }
  }
}
</script>

<style>
</style>
